import { useEffect } from 'react';
import { X } from 'lucide-react';

export function Modal({ open, onClose, title, subtitle, children, size = 'md', footer }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    if (open) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  const widths = { sm: 480, md: 640, lg: 880, xl: 1080 };
  return (
    <div
      className="fade-in"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(20,23,26,.45)',
        zIndex: 100, display: 'flex', alignItems: 'flex-start',
        justifyContent: 'center', padding: '6vh 16px', overflowY: 'auto',
        backdropFilter: 'blur(2px)',
      }}
      onClick={onClose}
    >
      <div
        className="scrollbar"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--surface)', borderRadius: 'var(--radius-lg)',
          width: '100%', maxWidth: widths[size], boxShadow: 'var(--shadow-lg)',
          border: '1px solid var(--border)', overflow: 'hidden',
        }}
      >
        <div style={{
          display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
          padding: '20px 24px 16px', borderBottom: '1px solid var(--border)',
        }}>
          <div>
            <h3 style={{ fontSize: 17, fontWeight: 700, margin: 0, letterSpacing: '-0.01em' }}>{title}</h3>
            {subtitle && <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--muted)' }}>{subtitle}</p>}
          </div>
          <button onClick={onClose} className="btn btn-ghost btn-sm btn-icon"><X size={16} /></button>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
        {footer && (
          <div style={{
            padding: '16px 24px', borderTop: '1px solid var(--border)',
            background: 'var(--surface-2)', display: 'flex', gap: 8, justifyContent: 'flex-end',
          }}>{footer}</div>
        )}
      </div>
    </div>
  );
}
